import { propertyGroups } from '../constants/config'

export function actorLogo (actor) {
  // Check if the logo property is present
  // if not, try logo.dev, if that fails, get the default image
  if (actor && actor.logo) {
    const logo = actor.logo.startsWith('http') || actor.logo.startsWith('/') ? actor.logo : 'https://public.datascouts.eu/' + actor.logo

    // If it's a logo.dev URL, append the token
    if (logo.includes('img.logo.dev')) {
      const token = import.meta.env.VITE_LOGO_DEV_PUBLISHABLE_KEY || ''
      // Check if token already exists in URL
      if (!logo.includes('token=') && token) {
        return `${logo}${logo.includes('?') ? '&' : '?'}token=${token}`
      }
    }

    return logo
  }

  // Fallback to logo.dev
  if (actor.url) {
    return getLogoDevLogoUrl(extractDomain(actor.url))
  }
}

export const ACTOR_LOGO_FALLBACK = '/images/ds-fallback.png'

export function onActorLogoError (event) {
  if (event.target.src !== window.location.origin + ACTOR_LOGO_FALLBACK) {
    event.target.src = ACTOR_LOGO_FALLBACK
  }
}

export function getLogoDevLogoUrl (domain) {
  const token = import.meta.env.VITE_LOGO_DEV_PUBLISHABLE_KEY || ''
  if (!domain) {
    return ''
  }
  return `https://img.logo.dev/${domain}?token=${token}`
}

export function extractDomain (url) {
  var domain = url
  if (url.indexOf('://') > -1) {
    domain = url.split('/')[2]
  }
  return domain.split('/')[0]
}

export function emptyActor () {
  const actor = {}
  const props = [].concat.apply([], Object.values(propertyGroups))
  for (var i = props.length - 1; i >= 0; i--) {
    actor[props[i]] = null
  }

  // funnel stage is not in the property groups as it's an "always private" property
  actor['funnel_stage'] = null

  return Object.assign(actor, {
    activities: [],
    expertises: [],
    motivations: [],
    sustainability_goal: [],
    domains: [],
    funding_structure: [],
    subsidiaries: [],
    tags: [],
    technology: [],
    industries: [],
    subIndustries: [],
  })
}

export function emptyAddress () {
  return {
    city: null,
    country: null,
    country_code: null,
    locality: null,
    number: null,
    street: null,
    zip: null,
  }
}
